import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppModeTitlePipe } from '@shared/pipes/shared-pipes/app-mode-title.pipe';
import { CheckTypePipe } from '@shared/pipes/shared-pipes/check-type.pipe';
import { DatepickerFormat } from '@shared/pipes/shared-pipes/datepicker-format';
import { DeviceLampOperTimePipe } from '@shared/pipes/shared-pipes/device-lamp-oper-time.pipe';
import {
  DeviceProcModesWithSurfacePipe,
  DeviceProcModeWithSurfacePipe
} from '@shared/pipes/shared-pipes/device-proc-mode-with-surface.pipe';
import { DeviceProcModePipe } from '@shared/pipes/shared-pipes/device-proc-mode.pipe';
import { DeviceStatePipe } from '@shared/pipes/shared-pipes/device-state.pipe';
import { DeviceStatusPipe } from '@shared/pipes/shared-pipes/device-status.pipe';
import { EmptyNoPipe } from '@shared/pipes/shared-pipes/empty-no.pipe';
import { EndWithPipe } from '@shared/pipes/shared-pipes/end-with.pipe';
import { FnAsyncPipe } from '@shared/pipes/shared-pipes/fn-async.pipe';
import { FnPipe } from '@shared/pipes/shared-pipes/fn.pipe';
import { GetColumnPipe } from '@shared/pipes/shared-pipes/get-column.pipe';
import { GetControlPipe } from '@shared/pipes/shared-pipes/get-control.pipe';
import { GetFormControlPipe, GetPropPipe } from '@shared/pipes/shared-pipes/get-prop.pipe';
import { JoinPipe } from '@shared/pipes/shared-pipes/join.pipe';
import { LimitTextPipe } from '@shared/pipes/shared-pipes/limit-text.pipe';
import { NotificationStatusPipe } from '@shared/pipes/shared-pipes/notification.status.pipe';
import { SurfaceTypePipe } from '@shared/pipes/shared-pipes/surface-type.pipe';
import { TypedPipe } from '@shared/pipes/shared-pipes/typed.pipe';
import { UserRolePipe } from '@shared/pipes/shared-pipes/user-role.pipe';
import { UserTypePipe } from '@shared/pipes/shared-pipes/user-type.pipe';
import { ToFormControlPipe } from './to-form-control.pipe';
import { SelectPlaceholderPipe } from './select-placeholder.pipe';
import { HighlightSearch } from '@shared/pipes/shared-pipes/highlight.pipe';
import { EmptyDashPipe } from './empty-dash.pipe';

@NgModule({
  declarations: [
    ToFormControlPipe,
    SelectPlaceholderPipe,
    DeviceStatePipe,
    DeviceStatusPipe,
    EmptyNoPipe,
    DatepickerFormat,
    UserRolePipe,
    JoinPipe,
    GetColumnPipe,
    LimitTextPipe,
    GetControlPipe,
    HighlightSearch,
    NotificationStatusPipe,
    UserTypePipe,
    TypedPipe,
    CheckTypePipe,
    FnPipe,
    FnAsyncPipe,
    DeviceProcModePipe,
    DeviceProcModeWithSurfacePipe,
    DeviceProcModesWithSurfacePipe,
    GetPropPipe,
    GetFormControlPipe,
    AppModeTitlePipe,
    EndWithPipe,
    DeviceLampOperTimePipe,
    EmptyDashPipe,
    SurfaceTypePipe
  ],
  exports: [
    ToFormControlPipe,
    SelectPlaceholderPipe,
    DeviceStatePipe,
    EmptyNoPipe,
    DatepickerFormat,
    JoinPipe,
    DeviceStatusPipe,
    LimitTextPipe,
    GetControlPipe,
    HighlightSearch,
    GetColumnPipe,
    NotificationStatusPipe,
    UserRolePipe,
    UserTypePipe,
    TypedPipe,
    FnPipe,
    FnAsyncPipe,
    DeviceProcModePipe,
    DeviceProcModeWithSurfacePipe,
    DeviceProcModesWithSurfacePipe,
    GetPropPipe,
    GetFormControlPipe,
    EndWithPipe,
    DeviceLampOperTimePipe,
    CheckTypePipe,
    EmptyDashPipe,
    AppModeTitlePipe,
    SurfaceTypePipe
  ],
  imports: [CommonModule],
})
export class SharedPipesModule {}
